<template>
  <span class="drift" :class="`drift--${match}`" :title="label.hint">
    <span class="drift__dot" aria-hidden="true" />
    {{ label.text }}<template v-if="delta"> · ΔE {{ delta }}</template>
  </span>
</template>

<script setup lang="ts">
  import type { DriftMatch } from './brand-kits';

  const { match, delta = null } = defineProps<{
    match: DriftMatch;
    delta?: number | null;
  }>();

  const LABELS: Record<DriftMatch, { text: string; hint: string }> = {
    exact: { text: 'in tokens', hint: 'A generated token holds exactly this hex' },
    near: {
      text: 'near',
      hint: 'A token is within ΔE 3 — the same colour to the eye, most likely re-typed by hand',
    },
    missing: {
      text: 'not in tokens',
      hint: 'No generated token comes close. Not automatically a bug: the brand kit is the house palette and covers print',
    },
  };

  const label = computed(() => LABELS[match]);
</script>

<style lang="postcss" scoped>
  .drift {
    display: inline-flex;
    gap: 0.375rem;
    align-items: center;

    padding: 0.125rem 0.4375rem;
    border: 1px solid currentcolor;
    border-radius: 1rem;

    font-size: 0.625rem;
    font-weight: 600;
    white-space: nowrap;
  }

  .drift__dot {
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
    background: currentcolor;
  }

  .drift--exact {
    color: #1a7f37;
  }

  .drift--near {
    color: #9a6700;
  }

  .drift--missing {
    color: #b4442c;
  }
</style>
